import { useState } from 'react'
import { Lightbox } from './Lightbox'

function getAspectClass(w) {
    return 'aspect-[16/9]';
}
/**
 * Pure display component for image blocks.
 * No editing UI. Safe to copy to frontend.
 */
export function ImageView({ url, fullUrl, caption, gridW, imagePosition, noAspect, enableLightbox = false, onOpenLightbox }) {
    const [lightboxSrc, setLightboxSrc] = useState(null)
    if (!url)
        return null;
    const posClass = imagePosition
        ? `w-4/5 ${imagePosition === 'right' ? 'ml-auto mr-0' : 'ml-0 mr-auto'}`
        : 'w-full';
    // onOpenLightbox 傳入時（例如 TransmissionView 統一相簿），交給外層管理；否則自己開獨立 Lightbox
    const zoomProps = (enableLightbox || onOpenLightbox)
        ? { className: 'cursor-zoom-in', onClick: () => onOpenLightbox ? onOpenLightbox(fullUrl || url) : setLightboxSrc(fullUrl || url) }
        : {}
    if (noAspect) {
        return (<>
          <div className={`relative ${posClass} rounded-[8px] overflow-hidden ${zoomProps.className ?? ''}`} onClick={zoomProps.onClick}>
            <img src={url} alt={caption || 'Image'} className="w-full h-auto block object-cover" loading="lazy"
              onLoad={() => window.dispatchEvent(new Event('resize'))}/>
          </div>
          {!onOpenLightbox && enableLightbox && lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
        </>);
    }
    const aspectClass = getAspectClass(gridW);
    return (<>
      <div className={`relative ${posClass} group`}>
        <div className={`relative rounded-[8px] overflow-hidden ${aspectClass} ${zoomProps.className ?? ''}`} onClick={zoomProps.onClick}>
          <img src={url} alt={caption || 'Image'} className="absolute inset-0 w-full h-full object-cover" loading="lazy"/>
        </div>
        {caption && (<p className="mt-2 text-sm text-center text-[#44413D]">{caption}</p>)}
      </div>
      {enableLightbox && lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
    </>);
}
